var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailRoundYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FECE2F",
    fillOpacity: 0.77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 27.1667L30.859 33.8348C31.6304 34.3747 32.016 34.6447 32.4356 34.7493C32.8061 34.8416 33.1937 34.8416 33.5643 34.7493C33.9838 34.6447 34.3695 34.3747 35.1408 33.8348L44.6666 27.1667M26.9333 42.3334H39.0666C41.0268 42.3334 42.0069 42.3334 42.7556 41.9519C43.4141 41.6164 43.9496 41.081 44.2851 40.4224C44.6666 39.6737 44.6666 38.6936 44.6666 36.7334V29.2667C44.6666 27.3066 44.6666 26.3265 44.2851 25.5778C43.9496 24.9192 43.4141 24.3838 42.7556 24.0482C42.0069 23.6667 41.0268 23.6667 39.0666 23.6667H26.9333C24.9731 23.6667 23.993 23.6667 23.2443 24.0482C22.5857 24.3838 22.0503 24.9192 21.7147 25.5778C21.3333 26.3265 21.3333 27.3066 21.3333 29.2667V36.7334C21.3333 38.6936 21.3333 39.6737 21.7147 40.4224C22.0503 41.081 22.5857 41.6164 23.2443 41.9519C23.993 42.3334 24.9731 42.3334 26.9333 42.3334Z",
    stroke: "#040320",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FECE2F",
    strokeOpacity: 0.48,
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRoundYellow);
export default __webpack_public_path__ + "static/media/mail_round_yellow.07845876f9c957ea1305d3f8f3325dcf.svg";
export { ForwardRef as ReactComponent };